import styled from 'styled-components';
import { Checkbox as DefaultCheckbox, Link as DefaultLink } from '~components';

export const Checkbox = styled(DefaultCheckbox)`
  align-items: flex-start;
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`;

export const Label = styled.span`
  font-size: ${({ theme }) => theme.font.size.m3};
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  color: ${({ theme }) => theme.color.text.neutral.strong};
  letter-spacing: -0.03em;
`;

export const Link = styled(DefaultLink)`
  text-decoration: underline;
`;
